import MainContainer from "./MainContainer";
import BigTitleText from "./BigTitleText";
import EventCard from "./EventCard";
import ShowMoreLink from "./ShowMoreLink";
import TitleTextSection from "./TitelTextSection";

const ListEventsSection = ({ listName, items }) => {
  return (
    <>
      <MainContainer noTopPadding={false}>
        <div className="pb-4">
          <div className="sm:py-4 flex justify-between items-center">
            <TitleTextSection
              title={listName}
              subtitle="Alla kommande musikevenemang i Strängnäs kommun"
            />
            <ShowMoreLink href="/events" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {items.map((event, index) => (
              <div key={event.slug || index} className="grid col-span-1">
                <EventCard event={event} />
              </div>
            ))}
          </div>
        </div>
      </MainContainer>
    </>
  );
};

export default ListEventsSection;
